import React from 'react'
import trashCanIcon from './../../../../assets/images/adminPanel/trash-can.png'

const DeleteButton = ({ deleteEntry, disabled, showAsterisk = false }) => {
	return (
		<td style={{ display: 'flex' }}>
			<button
				onClick={disabled ? () => {} : deleteEntry}
				style={{
					opacity: disabled ? 0.5 : 1,
					border: 'none',
					background: 'inherit',
					cursor: disabled ? 'default' : 'pointer',
				}}
			>
				<img src={trashCanIcon} style={{ height: '21px' }} />
			</button>

			{/* showAsterisk determines, whether to display an asterisk in the group table, that reffers to an explanation why the delete button is disabled. */}
			{showAsterisk && <p style={{ margin: 0, fontSize: '24px' }}>*</p>}
		</td>
	)
}

export default DeleteButton
